var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskInspectionOther = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 15.584q.816 0 1.416.6t.6 1.416-.6 1.416-1.416.6-1.416-.6-.6-1.416.6-1.416 1.416-.6m0-6q.816 0 1.416.6t.6 1.416-.6 1.416-1.416.6-1.416-.6-.6-1.416.6-1.416 1.416-.6m0-1.968q-.816 0-1.416-.6t-.6-1.416.6-1.416 1.416-.6 1.416.6.6 1.416-.6 1.416-1.416.6"
})));
export default SvgTaskInspectionOther;